import React from 'react'

import {
  Box,
  Display,
  FlexDirection,
  JustifyContent,
  AlignItems,
  Text,
  FontWeight,
  Button,
} from '@gousto-internal/citrus-react'
import { useDispatch } from 'react-redux'

import { ExplanationBox } from './ExplanationBox'
import { blockData, pageTitle, nextStepCTA } from './data'
import { trackClickContinueToBoxSize } from './snowplowActions'
import { ExplainTheWizardContent } from './styled'

type ExplainTheWizardProps = {
  next: () => void
}
export const ExplainTheWizard = ({ next }: ExplainTheWizardProps) => {
  const dispatch = useDispatch()

  const onClickContinueToBoxSize = () => {
    dispatch(trackClickContinueToBoxSize())
    next()
  }

  return (
    <Box
      data-testid="ExplainTheWizard"
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      justifyContent={JustifyContent.FlexStart}
      alignItems={AlignItems.FlexStart}
    >
      <Box paddingBottom={4}>
        <Text fontWeight={FontWeight.SemiBold} size={5}>
          {pageTitle}
        </Text>{' '}
      </Box>
      <ExplainTheWizardContent>
        {blockData.map(({ title, icon, text, type, trackingAction }, index) => (
          <ExplanationBox
            key={type}
            title={title}
            icon={icon}
            text={text}
            type={type}
            order={index + 1}
            trackingAction={trackingAction}
          />
        ))}
      </ExplainTheWizardContent>

      <Box
        style={{ alignSelf: 'center' }}
        paddingV={[5, 6]}
        paddingBottom={[0, 0]}
        width={['100%', '351px']}
      >
        <Button onClick={onClickContinueToBoxSize} width="100%" height="48px">
          {nextStepCTA}
        </Button>
      </Box>
    </Box>
  )
}
